import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import isEmpty from 'lodash.isempty';
import isRegExp from 'lodash.isregexp';
import MaskedInput from 'react-text-mask';
import { Button, Checkbox } from '../../../../components';

const PRACTICE_CODE_MASK = [/[0-9a-zA-Z]/, /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, '-', /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, '-', /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, /[0-9a-zA-Z]/];

export default class TemplateItemModal extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool.isRequired,
		onCancel: PropTypes.func.isRequired,
		onAdd: PropTypes.func.isRequired,
		isProvidingPractice: PropTypes.bool
	}

	static defaultProps = {
		isOpen: false,
		isProvidingPractice: true
	}

	practiceCodeRef = React.createRef()

	state = {
		agreeToTerms: false,
		virtualPracticeCode: ''
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.isOpen && this.props.isOpen) {
			this.setState({
				agreeToTerms: false,
				virtualPracticeCode: ''
			});
		}
	}

	handleAgreeToTermsChange = ({ target }) => {
		this.setState({ agreeToTerms: target.checked });
	}

	handleVirtualPracticeCodeChange = ({ target }) => {
		this.setState({ virtualPracticeCode: target.value.toUpperCase() });
	}

	handleAdd = () => {
		const { virtualPracticeCode } = this.state;
		if (virtualPracticeCode) {
			this.props.onAdd(virtualPracticeCode.split('-').join(''));
		} else {
			this.props.onAdd();
		}
	}

	isCodeInvalid = () => {
		const { virtualPracticeCode } = this.state;
		let invalid = isEmpty(virtualPracticeCode) || virtualPracticeCode.length != PRACTICE_CODE_MASK.length;
		if (!invalid) {
			invalid = [...virtualPracticeCode].reduce((prev, char, index) => {
				let isCurrentCharInvalid = false;
				if (isRegExp(PRACTICE_CODE_MASK[index])) {
					isCurrentCharInvalid = !char.match(PRACTICE_CODE_MASK[index]);
				} else {
					isCurrentCharInvalid = PRACTICE_CODE_MASK[index] !== char;
				}
				return prev || isCurrentCharInvalid; // true or false
			}, invalid);
		}
		return invalid;
	}

	render() {
		const { isOpen, onCancel, isProvidingPractice } = this.props;
		const { agreeToTerms, virtualPracticeCode } = this.state;
		const isValid = (agreeToTerms && !isProvidingPractice) || (agreeToTerms && isProvidingPractice && !this.isCodeInvalid());
		return (
			<Modal isOpen={isOpen} contentLabel="Add Appointment Slot" className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<div className="clearfix">
							<div className="pull-right">
								<button className="btn btn-link" onClick={onCancel}>
									<em className="fa fa-lg fa-times" />
								</button>
							</div>
							<h3 className="modal-title">
								Confirm Business Associate Agreement
							</h3>
						</div>
					</div>
					<div className="modal-body form">
						<pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
							By adding this practice, I represent and warrant that I am a &#34;Business Associate&#34; as that{' '}
							term is defined at 45 CFR 160.103 and that I presently have in place a Business Associate{' '}
							Agreement compliant with 45 CFR 164.504(e) between myself/my organization and the entity{' '}
							with whom I am connecting via Care Convene. I further represent and warrant that I will not{' '}
							use Care Convene to access any information for which a Business Associate Agreement may be{' '}
							required by any federal law, rule, or regulation, including without limitation 45 CFR 164.502,{' '}
							without having in place at the time I access such information a valid Business Associate Agreement.
						</pre>
						<div className="form-group">
							<Checkbox
								label="I agree to the above"
								checked={agreeToTerms}
								onChange={this.handleAgreeToTermsChange}
							/>
						</div>
						{isProvidingPractice && (
							<div className="form-group">
								<label htmlFor="practice_code">Practice Code</label>
								<MaskedInput
									ref={this.practiceCodeRef}
									className="form-control"
									id="practice_code"
									value={virtualPracticeCode}
									onChange={this.handleVirtualPracticeCodeChange}
									mask={PRACTICE_CODE_MASK}
									disabled={!agreeToTerms}
									placeholder="A1C-H2J-X3Z"
								/>
							</div>
						)}
					</div>
					<div className="modal-footer">
						<div className="pull-right">
							<Button
								title="Cancel"
								large
								onClick={onCancel}
							/>
							<Button
								title="OK"
								onClick={this.handleAdd}
								disabled={!isValid}
								large
								primary
								className="ml"
							/>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}
